const content: { [key: string]: string } = {
  ConfidentialUser: "Confidential User",
  notAvailable: "N/A",
};

export default content;
